import React from "react";
import { AsideIcon } from "./index-styled";
import * as S from "./discounts-styled";
import TagIcon from "_c/icon/Tag";
import DenyIcon from "_c/icon/Deny";
import isempty from "lodash/isEmpty";
import Tooltip from "_c/Tooltip";
import Info from "_c/atoms/Info";
import PT from "prop-types";
import { MasterDiscountsService } from "@/services/masterDiscounts";
import { useMut } from "@/hooks/useMut";

const ns = "master_profile:aside_discounts";
const Discounts = ({ t, ...props }) => {
  return (
    <S.Block
      id="master_discounts_sect"
      style={{ height: "auto", minHeight: "160px" }}
    >
      <AsideIcon>
        <TagIcon color="var(--font-color-emp)" />
      </AsideIcon>
      <S.EnhancedTitle>
        {t("master_profile:blocks_titles.discounts")}
      </S.EnhancedTitle>
      <ul>
        {props.modelSearchService && (
          <S.Li>
            <Tooltip
              title={t(`${ns}.model_tip`, {
                service: props.modelSearchService.title,
              })}
            >
              <span>{t(`${ns}.model`)}</span>
            </Tooltip>
          </S.Li>
        )}
        {isempty(props.discounts) ? (
          <Info>
            {props.isOwner
              ? t("master_profile:blocks_empty.discounts_user")
              : t("master_profile:blocks_empty.discounts_guest")}
          </Info>
        ) : (
          props.discounts.map((discount) => (
            <Discount
              key={discount._id}
              discount={discount}
              isOwner={props.isOwner}
              t={t}
            />
          ))
        )}
      </ul>
    </S.Block>
  );
};
Discounts.propTypes = {
  discounts: PT.array,
  isOwner: PT.bool,
  theme: PT.object,

  t: PT.func.isRequired,
};

const Discount = ({ discount, isOwner, t }) => {
  const { _id, desc, model_search } = discount;
  const removeMut = useMut(() => MasterDiscountsService.removeDiscount(_id), {
    t,
    confirm: true,
    notifyOnError: true,
  });
  if (model_search) return null;
  return (
    <S.Li key={_id}>
      <>
        {isOwner && (
          <S.RemoveButton
            disabled={removeMut.isLoading}
            onClick={() => removeMut.mutate()}
          >
            <DenyIcon color="white" width="8" />
          </S.RemoveButton>
        )}
        <span>
          {t(`${ns}.${desc.type}`, {
            amount: desc.amount,
            service: desc.service,
          })}
        </span>
      </>
    </S.Li>
  );
};

export default Discounts;
